export default __webpack_public_path__ + "static/B0006-d1063adf9fa67d4b58b0898873d7918f.png";